export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    rock: {
      key: 'rock',
      name: 'entity.asteroidBelt.situation.rock',
    },
    spy: {
      key: 'spy',
      name: 'entity.asteroidBelt.situation.spy',
    },
    minerals: {
      key: 'minerals',
      name: 'entity.asteroidBelt.situation.minerals',
    },
    ruins: {
      key: 'ruins',
      name: 'entity.asteroidBelt.situation.ruins',
    },
    war: {
      key: 'war',
      name: 'entity.asteroidBelt.situation.war',
    },
  },
};
